export default __webpack_public_path__ + "static/stopvaping-a4b6bd2b6b3c64941a8807d8d01ae690.webp";